import PropTypes from "prop-types";
import { Pagination } from "react-bootstrap";

const PaginationComponent = ({
  data,
  currentPage,
  itemsPerPage,
  onPageChange,
  scrollToTop = true
}) => {
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const pageNumbers = Array.from({ length: totalPages }, (_, idx) => idx + 1);

  let startPage;
  let endPage;

  if (currentPage <= 3) {
    startPage = 1;
    endPage = 3;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 2;
    endPage = totalPages;
  } else {
    startPage = currentPage - 0;
    endPage = currentPage + 0;
  }

  const adjustedPageNumbers = pageNumbers.slice(startPage - 1, endPage);

  const handleChangePage = (page) => {
    onPageChange(page);
    if(scrollToTop) window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Pagination className="mb-2 justify-content-center">
      <Pagination.Prev
        className="mx-2 Prev"
        disabled={currentPage === 1}
        onClick={() => handleChangePage(currentPage - 1)}
      />
      {totalPages <= 5 ? (
        pageNumbers.map((number, idx) => (
          <Pagination.Item
            key={idx}
            className="mx-2"
            active={number === currentPage}
            onClick={() => handleChangePage(number)}
          >
            {number}
          </Pagination.Item>
        ))
      ) : (
        <>
          {currentPage > 3 && (
            <>
              <Pagination.Item
                className="mx-2"
                onClick={() => handleChangePage(1)}
              >
                1
              </Pagination.Item>
              <Pagination.Ellipsis className="mx-2" />
            </>
          )}

          {adjustedPageNumbers.map((number) => (
            <Pagination.Item
              key={number}
              className="mx-2"
              active={number === currentPage}
              onClick={() => handleChangePage(number)}
            >
              {number}
            </Pagination.Item>
          ))}

          {currentPage <= totalPages - 3 && (
            <>
              <Pagination.Ellipsis className="mx-2" />
              <Pagination.Item
                className="mx-2"
                onClick={() => handleChangePage(totalPages)}
              >
                {totalPages}
              </Pagination.Item>
            </>
          )}
        </>
      )}
      <Pagination.Next
        className="mx-2 Next"
        disabled={currentPage === totalPages}
        onClick={() => handleChangePage(currentPage + 1)}
      />
    </Pagination>
  );
};

PaginationComponent.propTypes = {
  data: PropTypes.array.isRequired,
  currentPage: PropTypes.number,
  itemsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  scrollToTop: PropTypes.bool
};

export default PaginationComponent;
